import { createFileRoute, redirect } from '@tanstack/react-router';

// The framework-branded sign-in page is replaced by the ported Harborlight
// login screen. Redirect any visitor to /login so no framework auth screen is
// reachable.
export const Route = createFileRoute('/auth/signin')({
  beforeLoad: () => {
    throw redirect({ to: '/login' });
  }
});
